var createElement = require("./vdom/create-element.js")

module.exports = createElement



/*****************
 ** WEBPACK FOOTER
 ** ./~/virtual-dom/create-element.js
 ** module id = 399
 ** module chunks = 0
 **/